<div class="main-div">
  <div class="pd-div">Payment Details</div>
  <div class="content-div">
    <div class="amount-div">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-12" style="margin-bottom: 15px">
          <div class="card-div">
            <h3 class="doller-div">
              <!-- ${{convertToDecimal(paymentDetails?.payments[0]?.totalAmount)}} -->

              ${{convertToDecimal(paymentDetails?.payments[0]?.totalAmount + paymentDetails?.payments[1]?.totalAmount)}}
            </h3>
            <div class="same-div">Total Earning</div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12 paddinl0">
          <div class="card-div">
            <h3 class="doller1-div">${{convertToDecimal(getData(false)?.totalAmount)}}</h3>
            <div class="same-div">Pending Amount</div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <div class="card-div">
            <h3 class="doller2-div">
              ${{convertToDecimal(getData(true)?.totalAmount)}}
              <!-- ${{convertToDecimal(paymentDetails?.payments[0]?.totalAmount + paymentDetails?.payments[1]?.totalAmount)}} -->
            </h3>
            <div class="same-div">Deposited Amount</div>
          </div>
        </div>
      </div>
      <div class="year-div">
        <div class="card-y-div">Year</div>
        <div class="drop-down">
          <div>
            <span (click)="toggleDropdown()">{{ selectedYear }}</span>
          </div>
          <div>
            <img
            style="transform: translate(14px, 0px);"
              (click)="toggleDropdown()"
              src="https://ceeyou-dev.s3.us-east-2.amazonaws.com/images/6/27/1687857851129-myFile-1687857851127.svg"
            />
          </div>
          <div>
            <ul class="dropdown-menu" [class.show]="isDropdownOpen">
              <li *ngFor="let year of years" (click)="selectYear(year)">
                {{ year }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="usgame-div" *ngFor="let order of ordersList">
          <div class="two-div">
            <div><h4 class="resto-div">{{order?.eventData?.eventTitle | titlecase}}</h4></div>
            <div class="john-div desktop-div"  *ngIf="order?.userData?.userType==3">
              <img
                class="png-div"
                [src]="order?.userData?.profilePicture ? order?.userData?.profilePicture : '../../../assets/icons/img_avatar.png'"
                alt="invalid"
              />
              <div class="name-div">{{order?.userData?.firstName | titlecase}} {{order?.userData?.lastName | titlecase}}</div>
            </div>
          </div>
          <div class="map-div">
            <div>
              <img src="../../../assets/icons/map-pin.svg" style="    margin-top: -3px;" height="24" width="24" alt="invalid" />
            </div>
            <div class="address-div">
              {{order?.addressData?.address}}
            </div>
          </div>
          <div class="john-div mobile-div" *ngIf="order?.userData?.userType==3">
            <img
              class="png-div"
              [src]="order?.userData?.profilePicture ? order?.userData?.profilePicture : '../../../assets/icons/img_avatar.png'"
              alt="invalid"
            />
            <div class="name-div">{{order?.userData?.firstName | titlecase}} {{order?.userData?.lastName | titlecase}}</div>
          </div>
          <div class="time-div">
            <div>
              <img src="../../../assets/icons/Calendar.png" alt="invalid" />
            </div>
            <div style="margin-top: 2px;">{{order?.eventData?.eventDate | date:'MMM dd, YYYY': 'UTC'}}</div>
            <div>
              <img src="../../../assets/icon/TimeCircle.png" alt="invalid" />
            </div>
            <div style="margin-top: 2px;">{{formatEventTime(order?.eventData?.eventDateTime)}}</div>
          </div>
          <div class="op-div desktop-icon mt-1">Order Price</div>
          <div class="order-div">
            <div class="amount1-div desktop-icon">${{convertToDecimal(order?.totalAmount)}}</div>
            <div class="two-btn">
              <div class="recevied-div" *ngIf="order?.userData?.userType==3">{{order?.isPaymentDone == true ? 'Paid By Player': 'Pending'}} </div>
              <div class="paid-div" *ngIf="order?.userData?.userType==2">{{order?.isPaymentDone == true ? 'Paid By Coach' : 'Pending'}} </div>
            </div>
          </div>
          <div class="mobile-btn1">
            <div class="op-div mobile-icon">Order Price</div>
            <div class="amount1-div mobile-icon">${{convertToDecimal(order?.totalAmount)}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
